import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import WizardLoading from "./loaders/wizard-loading"
import AccordionContent from "./wizard-options/accordion-content"
import AccordionHeading from "./wizard-options/accordion-heading"

const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 20px;
  margin: 0 16px;
  overflow: hidden;
  ${(props) => props.theme.mediaQueries.tablet`
    border-radius: 0;
    margin: 0;
  `}
`
const Accordion = styled.div`
  ${(props) => props.theme.mediaQueries.mobileOnly`
    &:first-child > div {
      border-top: none;
    }
  `}
`

const InternalWizardOptions = ({ adminMode, prefOrder, wizardLoading }) => (
  <Container>
    {!wizardLoading ? (
      prefOrder.map((pref) => {
        if (adminMode && pref == "gift") {
          return
        }
        return (
          <Accordion data-cy={`wizard-accordion-${pref}`} key={`wopt-${pref}`}>
            <AccordionHeading pref={pref} />
            <AccordionContent panel={pref} pref={pref} />
          </Accordion>
        )
      })
    ) : (
      <WizardLoading />
    )}
  </Container>
)

InternalWizardOptions.propTypes = {
  adminMode: PropTypes.bool,
  prefOrder: PropTypes.array,
  styleCode: PropTypes.string,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    adminMode: state.wizard.adminMode,
    prefOrder: state.wizard.prefOrder,
    styleCode: state.wizard.description.style_code,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => {
  return {}
}

const WizardOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalWizardOptions)

export default WizardOptions
